import debounce from '../../helpers/debounce';

function getScrollXY() {
  let scrOfX = 0, scrOfY = 0;
  if (typeof( window.pageYOffset ) == 'number') {
    //Netscape compliant
    scrOfY = window.pageYOffset;
    scrOfX = window.pageXOffset;
  } else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
    //DOM compliant
    scrOfY = document.body.scrollTop;
    scrOfX = document.body.scrollLeft;
  } else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
    //IE6 standards compliant mode
    scrOfY = document.documentElement.scrollTop;
    scrOfX = document.documentElement.scrollLeft;
  }
  return [scrOfX, scrOfY];
}

function getDocHeight() {
  let D = document;
  let _body = document.body;

  return Math.max(
    _body.scrollHeight, D.documentElement.scrollHeight,
    _body.offsetHeight, D.documentElement.offsetHeight,
    _body.clientHeight, D.documentElement.clientHeight
  );
}

function calculateFirstParents(elements) {
  if (!elements || !elements.length) return;

  let DISTANCE_CONST = 650;
  let elementsChildren = elements.find('> .menu.-submenu');
  let innerWidth = window.innerWidth;

  if (innerWidth < 1280) {
    elementsChildren.attr('style', '');
    return;
  }

  elements.each((index, el) => {
    let rect = el.getBoundingClientRect();

    let elWidth        = rect.width;
    let distanceRight  = innerWidth - rect.right;
    let childElSubmenu = $(el).find('> .menu.-submenu');

    if ((distanceRight + elWidth) < DISTANCE_CONST) {
      let value = index === elements.length - 1 ? '0' : '-18px';

      childElSubmenu.attr('style', `left: auto; right: ${value}`);
    } else {
      childElSubmenu.attr('style', '');
    }
  });
}

function positionSubmenu() {
  const menuItem = document.querySelectorAll('.js-moreTrigger');

  if (!menuItem) return;

  menuItem.forEach(el => {
    const subMenu = el.querySelector('.moreMenu');

    if (!subMenu) return;

    const menuItemRect = el.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const rightOffset = viewportWidth - (menuItemRect.left + menuItemRect.width);

    subMenu.style.right = `-${rightOffset}px`;
  });
}

export default ($) => {
  let _body = document.body;
  let saved_scroll_position = 0;
  let current_scroll_position;
  let firstParentElements = $('.site__nav .menu > .menu-item-has-children');

  let doc = $(document);

  _body.classList.toggle('scroll', doc.scrollTop() > 50);

  window.addEventListener('scroll', function () {
    current_scroll_position = window.pageYOffset;

    if (saved_scroll_position < current_scroll_position && current_scroll_position > 50) {
      _body.classList.remove('slideDown');
      _body.classList.add('slideUp');
    } else if ((saved_scroll_position > current_scroll_position) && (getDocHeight() - 50 > getScrollXY()[1] + window.innerHeight)) {
      _body.classList.remove('slideUp');
      _body.classList.add('slideDown');
    }

    saved_scroll_position = current_scroll_position;

    if (window.pageYOffset >= 50) {
      _body.classList.add('fixed-nav', 'scrolled');
    } else {
      _body.classList.remove('fixed-nav');
    }
  });

  calculateFirstParents(firstParentElements);
  positionSubmenu();

  window.addEventListener('resize', debounce(function () {
    calculateFirstParents(firstParentElements);
    positionSubmenu();
  }, 500));
}